(function () {
  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) {
      return false;
    }
    return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
  }

  function findEmptyStateElement() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.textContent.indexOf('No reviews collected') !== -1) {
        return node.parentElement;
      }
    }
    return null;
  }

  var observer;
  var debounceTimer;
  var hardStopTimer;
  var decided = false;

  function decide() {
    if (decided) return;
    decided = true;

    var emptyStateEl = findEmptyStateElement();
        // Inside the closed mobile reviews accordion the text is hidden, so treat it as visible
    if (emptyStateEl && (isVisible(emptyStateEl) || emptyStateEl.closest('.reviews-accordion'))) {
      var wrapper = emptyStateEl.closest('[id^="shopify-section-"]');
      if (wrapper) wrapper.style.display = 'none';
    }

    if (observer) observer.disconnect();
    clearTimeout(debounceTimer);
    clearTimeout(hardStopTimer);
  }

  function scheduleDecision() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(decide, 900);
  }

  function init() {
    observer = new MutationObserver(function () {
      scheduleDecision();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // also check once in case nothing ever mutates after load
    scheduleDecision();

    // absolute safety net so we never watch forever
    hardStopTimer = setTimeout(decide, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();